var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-dossier-bg-violet';
                    var viewUrl = 'sprite.svg#view-icon-dossier-bg-violet';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 52 50',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };